import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { toast } from 'react-hot-toast';
import { AuthContext } from '../App';

const GestionRedesSociales = () => {
  const { user, API } = useContext(AuthContext);

  const [redesSociales, setRedesSociales] = useState({
    facebook_url: '',
    instagram_url: '',
    youtube_url: '',
    twitter_url: '',
    linkedin_url: '',
    tiktok_url: '',
    webpage_url_1: '',
    webpage_url_1_nombre: '',
    webpage_url_2: '',
    webpage_url_2_nombre: '',
    webpage_url_3: '',
    webpage_url_3_nombre: ''
  });

  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    cargarRedesSociales();
  }, []);

  const cargarRedesSociales = async () => {
    try {
      const response = await axios.get(`${API}/public/redes-sociales`);
      setRedesSociales(response.data);
    } catch (error) {
      console.error('Error cargando redes sociales:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGuardando(true);

    try {
      console.log('📤 Enviando datos:', redesSociales);
      const response = await axios.put(`${API}/admin/redes-sociales`, redesSociales);
      console.log('✅ Respuesta del servidor:', response.data);
      toast.success('Enlaces de redes sociales actualizados correctamente');
      // Recargar para confirmar que se guardó
      await cargarRedesSociales();
    } catch (error) {
      console.error('❌ Error completo:', error);
      console.error('❌ Respuesta del servidor:', error.response?.data);
      toast.error(`Error al actualizar redes sociales: ${error.response?.data?.detail || error.message}`);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
          <i className="fas fa-share-alt text-blue-600"></i>
          Gestión de Redes Sociales
        </h1>
        <p className="text-gray-600 mt-2">
          Configura los enlaces a tus redes sociales que aparecerán en el footer del landing page
        </p>
      </div>

      <Card>
        <CardHeader className="bg-gradient-to-r from-blue-50 to-purple-50">
          <CardTitle className="flex items-center gap-2">
            <i className="fas fa-link text-blue-600"></i>
            Enlaces de Redes Sociales
          </CardTitle>
        </CardHeader>
        <CardContent className="p-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Facebook */}
            <div>
              <Label htmlFor="facebook" className="text-base font-semibold flex items-center gap-2 mb-2">
                <i className="fab fa-facebook text-blue-600 text-xl"></i>
                Facebook
              </Label>
              <Input
                id="facebook"
                type="url"
                placeholder="https://facebook.com/tuPagina"
                value={redesSociales.facebook_url || ''}
                onChange={(e) => setRedesSociales({ ...redesSociales, facebook_url: e.target.value })}
                className="h-12"
              />
              <p className="text-xs text-gray-500 mt-1">
                <i className="fas fa-info-circle mr-1"></i>
                Deja vacío para no mostrar este icono
              </p>
            </div>

            {/* Instagram */}
            <div>
              <Label htmlFor="instagram" className="text-base font-semibold flex items-center gap-2 mb-2">
                <i className="fab fa-instagram text-pink-600 text-xl"></i>
                Instagram
              </Label>
              <Input
                id="instagram"
                type="url"
                placeholder="https://instagram.com/tuPerfil"
                value={redesSociales.instagram_url || ''}
                onChange={(e) => setRedesSociales({ ...redesSociales, instagram_url: e.target.value })}
                className="h-12"
              />
              <p className="text-xs text-gray-500 mt-1">
                <i className="fas fa-info-circle mr-1"></i>
                Deja vacío para no mostrar este icono
              </p>
            </div>

            {/* YouTube */}
            <div>
              <Label htmlFor="youtube" className="text-base font-semibold flex items-center gap-2 mb-2">
                <i className="fab fa-youtube text-red-600 text-xl"></i>
                YouTube
              </Label>
              <Input
                id="youtube"
                type="url"
                placeholder="https://youtube.com/@tuCanal"
                value={redesSociales.youtube_url || ''}
                onChange={(e) => setRedesSociales({ ...redesSociales, youtube_url: e.target.value })}
                className="h-12"
              />
              <p className="text-xs text-gray-500 mt-1">
                <i className="fas fa-info-circle mr-1"></i>
                Deja vacío para no mostrar este icono
              </p>
            </div>

            {/* Twitter */}
            <div>
              <Label htmlFor="twitter" className="text-base font-semibold flex items-center gap-2 mb-2">
                <i className="fab fa-twitter text-sky-500 text-xl"></i>
                Twitter / X
              </Label>
              <Input
                id="twitter"
                type="url"
                placeholder="https://twitter.com/tuPerfil"
                value={redesSociales.twitter_url || ''}
                onChange={(e) => setRedesSociales({ ...redesSociales, twitter_url: e.target.value })}
                className="h-12"
              />
              <p className="text-xs text-gray-500 mt-1">
                <i className="fas fa-info-circle mr-1"></i>
                Deja vacío para no mostrar este icono
              </p>
            </div>

            {/* LinkedIn */}
            <div>
              <Label htmlFor="linkedin" className="text-base font-semibold flex items-center gap-2 mb-2">
                <i className="fab fa-linkedin text-blue-700 text-xl"></i>
                LinkedIn
              </Label>
              <Input
                id="linkedin"
                type="url"
                placeholder="https://linkedin.com/company/tuEmpresa"
                value={redesSociales.linkedin_url || ''}
                onChange={(e) => setRedesSociales({ ...redesSociales, linkedin_url: e.target.value })}
                className="h-12"
              />
              <p className="text-xs text-gray-500 mt-1">
                <i className="fas fa-info-circle mr-1"></i>
                Deja vacío para no mostrar este icono
              </p>
            </div>

            {/* TikTok */}
            <div>
              <Label htmlFor="tiktok" className="text-base font-semibold flex items-center gap-2 mb-2">
                <i className="fab fa-tiktok text-gray-800 text-xl"></i>
                TikTok
              </Label>
              <Input
                id="tiktok"
                type="url"
                placeholder="https://tiktok.com/@tuPerfil"
                value={redesSociales.tiktok_url || ''}
                onChange={(e) => setRedesSociales({ ...redesSociales, tiktok_url: e.target.value })}
                className="h-12"
              />
              <p className="text-xs text-gray-500 mt-1">
                <i className="fas fa-info-circle mr-1"></i>
                Deja vacío para no mostrar este icono
              </p>
            </div>

            {/* Sitio Web 1 */}
            <div className="border-t pt-6 mt-6">
              <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                <i className="fas fa-globe text-purple-600"></i>
                Enlaces a Sitios Web Adicionales
              </h3>
              
              <div className="space-y-3">
                <div>
                  <Label htmlFor="webpage1_nombre" className="text-sm font-medium">
                    Nombre del Sitio Web 1
                  </Label>
                  <Input
                    id="webpage1_nombre"
                    type="text"
                    placeholder="Ej: Sede Principal, Iglesia Matriz, etc."
                    value={redesSociales.webpage_url_1_nombre || ''}
                    onChange={(e) => setRedesSociales({ ...redesSociales, webpage_url_1_nombre: e.target.value })}
                    className="h-10"
                  />
                </div>
                <div>
                  <Label htmlFor="webpage1" className="text-sm font-medium">
                    URL del Sitio Web 1
                  </Label>
                  <Input
                    id="webpage1"
                    type="url"
                    placeholder="https://tusitio.com"
                    value={redesSociales.webpage_url_1 || ''}
                    onChange={(e) => setRedesSociales({ ...redesSociales, webpage_url_1: e.target.value })}
                    className="h-10"
                  />
                </div>
              </div>
            </div>

            {/* Sitio Web 2 */}
            <div className="space-y-3">
              <div>
                <Label htmlFor="webpage2_nombre" className="text-sm font-medium">
                  Nombre del Sitio Web 2
                </Label>
                <Input
                  id="webpage2_nombre"
                  type="text"
                  placeholder="Ej: Blog, Tienda Online, etc."
                  value={redesSociales.webpage_url_2_nombre || ''}
                  onChange={(e) => setRedesSociales({ ...redesSociales, webpage_url_2_nombre: e.target.value })}
                  className="h-10"
                />
              </div>
              <div>
                <Label htmlFor="webpage2" className="text-sm font-medium">
                  URL del Sitio Web 2
                </Label>
                <Input
                  id="webpage2"
                  type="url"
                  placeholder="https://otrositio.com"
                  value={redesSociales.webpage_url_2 || ''}
                  onChange={(e) => setRedesSociales({ ...redesSociales, webpage_url_2: e.target.value })}
                  className="h-10"
                />
              </div>
            </div>

            {/* Sitio Web 3 */}
            <div className="space-y-3">
              <div>
                <Label htmlFor="webpage3_nombre" className="text-sm font-medium">
                  Nombre del Sitio Web 3
                </Label>
                <Input
                  id="webpage3_nombre"
                  type="text"
                  placeholder="Ej: Partners, Colaboradores, etc."
                  value={redesSociales.webpage_url_3_nombre || ''}
                  onChange={(e) => setRedesSociales({ ...redesSociales, webpage_url_3_nombre: e.target.value })}
                  className="h-10"
                />
              </div>
              <div>
                <Label htmlFor="webpage3" className="text-sm font-medium">
                  URL del Sitio Web 3
                </Label>
                <Input
                  id="webpage3"
                  type="url"
                  placeholder="https://tercersitio.com"
                  value={redesSociales.webpage_url_3 || ''}
                  onChange={(e) => setRedesSociales({ ...redesSociales, webpage_url_3: e.target.value })}
                  className="h-10"
                />
              </div>
            </div>

            {/* Botón de Guardar */}
            <div className="pt-4 border-t">
              <Button
                type="submit"
                disabled={guardando}
                className="w-full md:w-auto bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold px-8 py-3 text-base"
              >
                {guardando ? (
                  <>
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Guardando...
                  </>
                ) : (
                  <>
                    <i className="fas fa-save mr-2"></i>
                    Guardar Cambios
                  </>
                )}
              </Button>
            </div>
          </form>

          {/* Información adicional */}
          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <h3 className="font-semibold text-blue-800 mb-2 flex items-center gap-2">
              <i className="fas fa-lightbulb"></i>
              Consejos
            </h3>
            <ul className="text-sm text-blue-700 space-y-1 ml-6 list-disc">
              <li>Solo se mostrarán los iconos de las redes que tengan URL configurada</li>
              <li>Asegúrate de copiar la URL completa (incluyendo https://)</li>
              <li>Los enlaces se abrirán en una nueva pestaña automáticamente</li>
              <li>Los cambios se reflejan inmediatamente en el landing page público</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default GestionRedesSociales;
